module.exports = __webpack_public_path__ + "img/66.2cc7a1e2.png";